﻿
export function isDomainTextValid(value: string) {
    value = value.trim();
    const re = /^[A-Za-z0-9.\*\-]+$/;
    return value.length > 5 && re.test(value);
}

export function isMultipleDomainTextValid(value: string) {
    const re = /^[A-Za-z0-9.,\*\- ]+$/;
    return value.length > 5 && re.test(value);
}

export function parseDomainList(domainValues: string): string[] {
    var rawDomains = domainValues.split(",");
    var trimmedDomains = rawDomains.map(x => x.trim());
    var finalDomains = [];
    trimmedDomains.forEach(domain => {
        if (domain.startsWith("*")) {
            finalDomains.push(domain);
            finalDomains.push(domain.substring(2));
        }
        else {
            finalDomains.push(domain);
        }
    });

    return finalDomains;
}
